namespace Nbs.Xlr8PageTemplate.Navigation {

  export enum DisplayMode {
    IconAndText = 0,
    IconOnly = 1,
    TextOnly = 2,
    Flyout = 3,
    Expand = 4
  }

  export enum MenuType {
    Both = 0,
    Desktop = 1,
    Mobile = 2
  }

  export type BadgeType = 'info' | 'error';

  export type MenuItem = Menu | Link;

  export interface Link {
    id?: string;
    desktopLinkId?: string;
    mobileLinkId?: string;
    label: string;
    icon?: string;
    displayMode?: DisplayMode;
    menuType?: MenuType;
    url?: string;
    openInTab?: boolean;
    isDisabled?: boolean;
    isSelected?: boolean;
    badge?: LinkBadge;
  }

  export interface Menu {
    id: string;
    label?: string;
    desc?: string;
    icon?: string;
    displayMode?: DisplayMode;
    menuType?: MenuType;
    childItems: MenuItem[];
    badge?: LinkBadge;
  }

  export interface LinkBadge {
    type?: BadgeType;
    label: string;
    value?: number;
    hide?: boolean;
  }
}
